import { IProblem } from "../ProblemGenerators/sharedTypes";

export type Stats = {
    [keyof: string] : Array<Stat>
}
export type Stat = {
    problem: IProblem;
    correct: number;
    incorrect: number;
    averageTime: number;

}
export function getStats() : Stats {
    const stats = localStorage.getItem("stats");
    if (stats === undefined || stats === null) {
        return { problems: [] };
    }
    return JSON.parse(stats) as Stats;
}
export function addToStats(problem: IProblem, wasCorrect: boolean) {
    let currentStats = getStats();

    if (!currentStats[problem.generator]) {
        currentStats[problem.generator] = [];
    }
    
    let probMatch = currentStats[problem.generator].find((x) => x.problem.display === problem.display );
    if (probMatch === undefined) {
        currentStats[problem.generator].push({
            problem: problem,
            correct: wasCorrect ? 1 : 0,
            incorrect: wasCorrect ? 0 : 1,
            averageTime: problem.timeToAnswer ?? 0,
        });
    }
    else {
        let newAvg = (probMatch.averageTime * (probMatch.correct + probMatch.incorrect));
        newAvg = newAvg + (problem.timeToAnswer ?? probMatch.averageTime);
        newAvg = newAvg / (probMatch.correct + probMatch.incorrect + 1)

        probMatch.averageTime = Math.round(newAvg);
        probMatch.correct += wasCorrect ? 1 : 0;
        probMatch.incorrect += wasCorrect ? 0 : 1;
    }

    localStorage.setItem("stats", JSON.stringify(currentStats));
}
export function resetStats() {
    localStorage.setItem("stats", JSON.stringify({ }));
}